import React, { useContext } from 'react';
import { AuthContext } from '../../../context/auth';
import Header from '../../../components/Header';
import Barra from '../../../components/barra';
/* import MenuRentaInmobiliaria from '../../../components/hacienda/rentaInmobiliaria/menuRentaInmobiliaria' */
import {TablaTiposRentas} from '../../../components/hacienda/rentaInmobiliaria/tablaTipoRentas';
 import Footer from '../../../components/Footer';

function TipoDeRentas() {

  let op = require('../../../../src/modulos/datos');
  const { user } = useContext(AuthContext);
  let per = JSON.parse(localStorage.getItem('permisos'));

  return (

    user && (
      <div style={{ height: "100vh", padding: 0 }}>
        <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
          <Header />
        </div>

        <div className="row col-md-12" style={{ height: "85%", padding: 0, margin: 0 }}>
       

          <div className="col-md-12" style={{ height: "100%", padding: 0 }}>
            <div className="col-md-12" style={{ height: "10%", padding: 0 }}>
 
{/*               <MenuRentaInmobiliaria permisos = {per}/> */}
            </div>

            <div className="col-md-12" style={{ height: "85%", padding:0 }}>

              <TablaTiposRentas/>

            </div>
          </div>
        </div>
       
        <div  className="col-md-12" style={{ height: "5%", padding: 0 }}>
           <Footer />
        </div>
      </div>

    )


  );
}


export default TipoDeRentas;
